import React, { useState } from 'react';
import { useQuery } from 'react-apollo';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

import { GET_SPECIALIZATION_MAPPING } from '../queries';
import SpecialtyCategoriesTab from './SpecialtyCategoryTab';
import SpecialtySettingsTab from './SpecialtySettingTab';
import SpecialtyMappingTab from './SpecialtyMappingTab';

const TABS = {
  mappings: 'Mappings',
  categories: 'Categories',
  settings: 'Settings'
};

const SpecialityMappingsTab = () => {
  const [activeTab, setActiveTab] = useState(TABS.mappings);

  const { data, loading } = useQuery(GET_SPECIALIZATION_MAPPING);

  if (loading) return <p>Loading...</p>;

  const mappings = (data && data.getSpecializationMapping) || [];

  return (
    <div>
      <h2 className="mb-4">Specialty Mapping</h2>

      <Nav tabs>
        {Object.values(TABS).map(tab => (
          <NavItem key={tab}>
            <NavLink
              className={classnames({ active: activeTab === tab })}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab} className="mt-4">
        <TabPane tabId={TABS.mappings}>
          <SpecialtyMappingTab mappings={mappings} />
        </TabPane>

        <TabPane tabId={TABS.categories}>
          <SpecialtyCategoriesTab />
        </TabPane>

        <TabPane tabId={TABS.settings}>
          <SpecialtySettingsTab />
        </TabPane>
      </TabContent>
    </div>
  );
};

export default SpecialityMappingsTab;
